import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule, APP_INITIALIZER } from '@angular/core';
import { ContractComponent } from '@spaq/modules/contract/contract.component';
import { ContractCancelComponent } from '@spaq/modules/contract/pages/contract-cancel.component';
import { ContractViewComponent } from '@spaq/modules/contract/pages/contract-view.component';

import { ParksModule } from '@spaq/modules/parks';
import { PaymentModule } from '@spaq/modules/payment';
import { ServicesModule } from '@spaq/modules/services';
import { SubscriptionModule } from '@spaq/modules/subscription';
import { UserModule } from '@spaq/modules/user';
import { UtilsModule } from '@spaq/modules/utils';
import { VehiclesModule } from '@spaq/modules/vehicles';
import { FormComponent } from '@spaq/shared/components/form';
import { FormModule } from '@spaq/shared/components/forms';
import { SharedCommonModule } from '@spaq/shared/shared-common.module';
import { SharedComponentsModule } from '@spaq/shared/shared-components.module';
import { SharedFormModule } from '@spaq/shared/shared-form.module';
import { TranslateModule } from '@ngx-translate/core';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IntlModule } from '@progress/kendo-angular-intl';
import { NgxMdModule } from 'ngx-md';
import {
	ContractBillingDetailsComponent,
	ContractCreateNavComponent,
	ContractHeaderComponent,
	ContractSearchFormComponent,
	ContractSummaryComponent,
	ContractTopMenuComponent,
	SubscriptionDetailsComponent
} from './components';
import {
	ContractConditionsPaymentComponent,
	ContractConditionsServiceComponent,
	ContractCreateComponent,
	ContractCreatePreviewComponent,
	ContractDetailsComponent,
	ContractImportComponent,
	ContractPayComponent,
	ContractSelectParkComponent,
	ContractSelectPaymentComponent,
	ContractSelectServiceComponent,
	ContractSummaryComponent as ContractSummaryComponentB,
	ContractUpdateSubscriptionComponent,
	ContractUpdateVehiclesComponent,
	SecureFormComponent
} from './pages';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { DebounceClickDirective } from '@spaq/modules/contract/click-debounce.directive';
import { MsalModule, MsalService } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType, LogLevel } from '@azure/msal-browser';
import { MsalBroadcastService } from '@azure/msal-angular';
import { environment } from '@spaq/configs/environment';

export function MSALInstanceFactory(): PublicClientApplication {
	const { clientId, tenantId, redirectUri } = environment.msal;
	return new PublicClientApplication({
		auth: {
			clientId,
			authority: 'https://login.microsoftonline.com/' + tenantId,
			redirectUri
		},
		cache: {
			cacheLocation: 'localStorage',
			storeAuthStateInCookie: false
		},
		system: {
			loggerOptions: {
				loggerCallback: () => {},
				logLevel: LogLevel.Error
			}
		}
	});
}
export function initializeMsal(msalService: MsalService): () => Promise<void> {
	return () => msalService.instance.initialize();
}
@NgModule({
	imports: [
		SharedCommonModule,
		HttpClientModule,
		ParksModule,
		ServicesModule,
		SharedComponentsModule,
		TranslateModule,
		DropDownsModule,
		//  RouterModule.forChild(routesContract),
		SubscriptionModule,
		VehiclesModule,
		PaymentModule,
		UserModule,
		DateInputsModule,
		IntlModule,
		SharedCommonModule,
		UtilsModule,
		NgxMdModule,
		FormModule,
		SharedFormModule,
		LayoutModule,
		MsalModule.forRoot(
			MSALInstanceFactory(),
			{
				interactionType: InteractionType.Popup,
				authRequest: {
					scopes: ['openid', 'profile', 'user.read']
				}
			},
			{
				interactionType: InteractionType.Popup,
				protectedResourceMap: new Map([
					['https://graph.microsoft.com/v1.0/me', ['user.read']],
					[`api://${environment.msal.clientId}/*`, [`${environment.msal.clientId}/.default`]]
				])
			}
		)
	],
	declarations: [
		ContractComponent,
		ContractDetailsComponent,
		ContractImportComponent,
		ContractSearchFormComponent,
		ContractViewComponent,
		ContractConditionsServiceComponent,
		ContractConditionsPaymentComponent,
		ContractCreateComponent,
		ContractSummaryComponent,
		ContractSummaryComponentB,
		SubscriptionDetailsComponent,
		ContractCancelComponent,
		ContractPayComponent,
		ContractHeaderComponent,
		ContractTopMenuComponent,
		ContractBillingDetailsComponent,
		ContractCreateNavComponent,
		ContractSelectParkComponent,
		ContractSelectServiceComponent,
		ContractSelectPaymentComponent,
		ContractUpdateSubscriptionComponent,
		ContractUpdateVehiclesComponent,
		ContractCreatePreviewComponent,
		DebounceClickDirective,
		SecureFormComponent
	],
	exports: [
		ContractComponent,
		ContractDetailsComponent,
		ContractImportComponent,
		ContractSearchFormComponent,
		ContractViewComponent,
		ContractConditionsServiceComponent,
		ContractConditionsPaymentComponent,
		ContractCreateComponent,
		ContractSummaryComponent,
		ContractSummaryComponentB,
		SubscriptionDetailsComponent,
		ContractCancelComponent,
		ContractPayComponent,
		ContractHeaderComponent,
		ContractTopMenuComponent,
		SecureFormComponent
	]
})
export class ContractModule {
	static forRoot(): ModuleWithProviders<ContractModule> {
		return {
			ngModule: ContractModule,
			providers: [FormComponent, MsalService, MsalBroadcastService]
		};
	}
}
